<ng-select class="select-bassa"
           bindValue="value"
           [items]="options"
           [disabled]="disabled"
           [clearable]="false"
           [(ngModel)]="value"
           (ngModelChange)="onChanged($event)">
</ng-select>